module.exports = {
  findPwd: {
    find: '找回密码',
    userName: '手机号或邮箱',
    error_userName_1: '请输入手机号或邮箱',
    error_userName_2: '用户不存在',
    get_code: '获取验证码',
    get_code_tip: '点击发送验证码',
    get_code_tip_re: '秒后重新发送',
    code: '验证码',
    error_code_1: '请输入验证码',
    error_code_2: '一天内发送验证码次数超过5次，今日无法再发送',
    error_code_3: '验证码错误',
    next: '下一步',
    input_password: '输入新密码',
    repeat_new_password: '重复新密码',
    new_password_error: '两次密码不一致',
    submit_new_password: '提交新密码',
    success_relogin: '密码重置成功，请重新登录',
    button_relogin: '重新登录'
  },
  register: {
    register: '注册',
    phone_register: '手机注册',
    email_register: '邮箱注册',
    phone: '请输入手机号',
    error_phone: '无效手机号',
    already_bound: '用户名已存在',
    not_support: '频道不支持',
    code: '验证码',
    code_error: '验证码错误',
    get_code: '获取验证码',
    get_code_tip_re: '秒后重新发送',
    error_code_1: '验证码不能为空',
    error_code_2: '一天内发送验证码次数超过5次，今日无法再发送',
    error_code_3: '验证码错误',
    error_code_4: '验证码已经被发送，它会在10min内有效',
    error_code_5: '请不要高频请求验证码',
    password_set: '8-20位字母及数字组合密码',
    password_error_1: '密码不能为空',
    protocol_a: '我已阅读并接受',
    protocol_b: '使用协议',
    submit: '提交',
    login_now: '立即登录',
    success: '欢迎您注册成者账号，恭喜您账号激活成功，请重新登陆！',
    login_re: '返回重新登录',
    email: '请输入邮箱',
    email_error: '邮箱格式不正确',
    email_already_bound: '该邮箱已经存在',
    accout_safe_tips: '为了您的账号安全，请绑定手机',
    password_repeat: '8-20位字母及数字组合密码',
    bind: '绑定',
    password: '设置密码'
  },
  success: {
    activation: '邮件已发送',
    activation_email: '您的激活邮件已发送至 ',
    click_email: '，点击邮件内激活按钮完成注册。',
    active_email: '没有收到确认邮件，链接过期， 怎么办？',
    email_help1: '● 看看是否会在回收站，垃圾邮件中？',
    email_help2: '● 重新发送，',
    activation_success: '激活成功',
    jumping_now: '立即跳转',
    activation_failed: '链接过期',
    valueText: '点击重新发送',
    jumpingText: '正在跳转（',
    get_code_tip_re: '秒后重新发送',
    code_error1: '一天只能发送5次验证码',
    code_error2: '发送失败'
  },
  index: {
    loginText: '登录',
    userName: '手机号/邮箱',
    password: '密码',
    forgetPwd: '忘记密码',
    register: '注册新用户',
    userTip: '请输入手机号/邮箱',
    pwdTip: '请输入密码',
    loginFail: '用户名或密码错误',
    errorFormat: '格式不正确',
    inactive: '账号未激活，请到邮箱激活',
    resend: '点此重发一封',
    success: '发送成功',
    info: '账号中心',
    protocol: '使用协议'
  },
  basic: {
  	editText: '编辑',
  	updateText: '修改',
  	logoutText: '退出登录',
  	czurId: '成者ID',
  	emailBind: '绑定邮箱',
  	phone: '安全手机',
  	password: '密码',
  	passwordSet: '(已设置)',
  	bindText: '绑定',
    unbindText: '(未绑定)',
  	navText: '个人中心',
  	emailAddress: '邮箱地址',
  	emailEmpty: '请输入邮箱地址',
  	emailInvalid: '无效的邮箱地址',
  	emailBinds: '该邮箱已绑定其他账号',
  	codeEmpty: '请输入验证码',
  	codeError: '验证码错误',
  	fiveTimes: '同一个邮箱，一天只能发送5次验证码',
  	hasSent: '验证码已经被发送，它会在10min内有效',
  	highFrequency: '请不要高频请求验证码',
  	emailCode: '邮箱验证码',
  	emailSend: '发送验证码',
  	Submit: '提交',
  	sendAgain: '秒后重新发送',
  	validateEmail: '验证邮箱',
  	emailSent: '已发送验证码到邮箱',
  	nextStep: '下一步',
  	successText: '修改成功',
  	finishText: '完成',
  	updatePwd: '修改密码',
  	oldPwd: '当前密码',
  	newPwd: '新密码',
  	confirmPwd: '确认新密码',
  	oldPwdInput: '请输入当前密码',
  	newPwdInput: '请输入新密码',
  	notSame: '新密码不能与原密码相同',
  	confirmPwdInput: '请输入确认密码',
  	notSameWith: '新密码与确认密码不一致',
  	oldPwdInvalidate: '原密码无效',
  	notExist: '用户不存在',
  	fiveTime: '同一个手机号，一天只能发送5次验证码',
  	validatePhone: '验证手机号',
  	phoneSent: '已发送验证码到手机',
  	phoneCode: '短信验证码',
  	phoneInput: '请输入手机号',
    error_phone: '无效手机号',
    already_bound: '该手机号已经绑定其他账号',
    bindPhone: '绑定手机',
    phoneNum: '手机号码',
    uploadImg: '上传图片',
    supportText: '只支持JPG, png, 大小不超过200KB',
    confirm: '确定',
    cancel: '取消',
    nicknameLong: '请输入14字符以内昵称',
    area: '地区',
    closeAcount: '注销账号',
    closeHint: '温馨提示',
    closeText: '成者云账号为成者 CZUR、极简扫描、成者极简扫描、Starry Meeting、Scanner通用账号,注销操作将会注销以上所有账号，请仔细确认。',
    closeWarning: '*账号一经注销，将销毁所有用户数据，请谨慎操作！',
    close: '注销',
    code: '验证码',
    slelctCountry: '选择地区',
    lowPw: '你的密码过于简单，必须修改密码后才能继续',
    logout: '退出',
    nicknameEmpty: '名字不能为空',
    nicknameEmoji: '禁止输入特殊符号或表情'
  },
  titleText: {
    account_center: '个人信息',
    privacy: '成者科技 - 隐私政策',
    create_account: '成者科技 - 注册中心',
    terms_service: '成者科技 - 使用协议',
    find_pwd: '成者科技 - 找回密码',
    active: '成者科技 - 激活',
    account_CZUR: '成者科技 - 账户中心'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/zh_CN.js